var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
export var switchLabelIdentifier = 'citrus-switch-label-c0d3d';
export var switchInput = (_a = {
        appearance: 'none',
        height: 0,
        width: 0,
        ':checked': (_b = {},
            _b["& + .".concat(switchLabelIdentifier)] = {
                ':before': {
                    backgroundColor: '#1588af',
                    content: 'attr(data-on)',
                    left: 4 + 64,
                },
                ':after': {
                    content: 'attr(data-off)',
                    left: 4,
                },
            },
            _b[':hover'] = (_c = {},
                _c["& + .".concat(switchLabelIdentifier)] = {
                    ':before': {
                        backgroundColor: '#41a8d2',
                    },
                },
                _c),
            _b),
        ':disabled': (_d = {},
            _d["& + .".concat(switchLabelIdentifier)] = {
                backgroundColor: '#eaeaea',
                cursor: 'not-allowed',
                ':before': {
                    backgroundColor: '#cccccc',
                },
                ':after': {
                    color: '#a6a6a6',
                },
            },
            _d[':hover'] = (_e = {},
                _e["& + .".concat(switchLabelIdentifier)] = {
                    ':before': {
                        backgroundColor: '#cccccc',
                    },
                },
                _e),
            _d),
        ':hover': (_f = {},
            _f["& + .".concat(switchLabelIdentifier)] = {
                ':before': {
                    backgroundColor: '#959595',
                },
            },
            _f),
        ':focus': (_g = {},
            _g["& + .".concat(switchLabelIdentifier)] = {
                boxShadow: "0 0 0 1px white, 0 0 0 3px ".concat('#085a7e'),
            },
            _g)
    },
    _a["& + .".concat(switchLabelIdentifier)] = {
        backgroundColor: '#ffffff',
        border: '1px solid #cccccc',
        borderRadius: 2,
        boxSizing: 'border-box',
        cursor: 'pointer',
        display: 'inline-block',
        height: 32,
        padding: 0,
        position: 'relative',
        width: 64 * 2 + 4 * 2 + 2,
        ':before': {
            background: '#666666',
            borderRadius: 2,
            color: '#ffffff',
            content: 'attr(data-off)',
            fontSize: 14,
            fontWeight: 500,
            height: 24 - 2,
            left: 4,
            lineHeight: "".concat(24 - 2, "px"),
            margin: 0,
            padding: 0,
            position: 'absolute',
            textAlign: 'center',
            top: 4,
            transition: 'left 0.15s ease-out',
            width: 64,
            zIndex: 1,
        },
        ':after': {
            color: '#666666',
            content: 'attr(data-on)',
            fontSize: 14,
            fontWeight: 500,
            height: 24 - 2,
            left: 4 + 64,
            lineHeight: "".concat(24 - 2, "px"),
            margin: 0,
            padding: 0,
            position: 'absolute',
            textAlign: 'center',
            top: 4,
            width: 64,
        },
    },
    _a);
export var switchCompact = (_h = {
        appearance: 'none',
        height: 0,
        width: 0,
        ':checked': (_j = {},
            _j["& + .".concat(switchLabelIdentifier)] = {
                backgroundColor: '#1588af',
                ':before': {
                    backgroundColor: '#ffffff',
                    backgroundImage: "url(\"data:image/svg+xml,%3Csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Ctitle%3Ebold/checkmark-bold%3C/title%3E%3Cpath fill='%231588af' id='Combined-Shape' class='st0' d='M66.7 107l60.5-86.4c.6-.9.4-2.1-.5-2.8l-9.8-6.9c-.9-.6-2.1-.4-2.8.5L54.5 96.6l-44.2-31c-.9-.6-2.2-.4-2.8.5L.6 75.9c-.6.9-.4 2.1.5 2.8l45.4 31.8c.1.1.2.3.4.4l9.8 6.9c.5.4 1.2.5 1.8.3.4-.1.8-.4 1.1-.8l6.9-9.8c.1-.2.2-.4.2-.5z'/%3E%3C/svg%3E\")",
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 12,
                    left: 24 - 4,
                },
            },
            _j[':disabled'] = (_k = {},
                _k["& + .".concat(switchLabelIdentifier)] = {
                    ':before': {
                        backgroundImage: "url(\"data:image/svg+xml,%3Csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Ctitle%3Ebold/checkmark-bold%3C/title%3E%3Cpath fill='%23a6a6a6' id='Combined-Shape' class='st0' d='M66.7 107l60.5-86.4c.6-.9.4-2.1-.5-2.8l-9.8-6.9c-.9-.6-2.1-.4-2.8.5L54.5 96.6l-44.2-31c-.9-.6-2.2-.4-2.8.5L.6 75.9c-.6.9-.4 2.1.5 2.8l45.4 31.8c.1.1.2.3.4.4l9.8 6.9c.5.4 1.2.5 1.8.3.4-.1.8-.4 1.1-.8l6.9-9.8c.1-.2.2-.4.2-.5z'/%3E%3C/svg%3E\")",
                    },
                },
                _k),
            _j[':hover'] = (_l = {},
                _l["& + .".concat(switchLabelIdentifier)] = {
                    backgroundColor: '#41a8d2',
                    ':before': {
                        backgroundColor: '#ffffff',
                    },
                },
                _l),
            _j),
        ':disabled': (_m = {},
            _m["& + .".concat(switchLabelIdentifier)] = {
                backgroundColor: '#cccccc',
                cursor: 'not-allowed',
                ':before': {
                    backgroundColor: '#eaeaea',
                },
            },
            _m[':hover'] = (_o = {},
                _o["& + .".concat(switchLabelIdentifier)] = {
                    backgroundColor: '#cccccc',
                    ':before': {
                        backgroundColor: '#eaeaea',
                    },
                },
                _o),
            _m),
        ':hover': (_p = {},
            _p["& + .".concat(switchLabelIdentifier)] = {
                backgroundColor: '#959595',
                ':before': {
                    backgroundColor: '#ffffff',
                },
            },
            _p),
        ':focus': (_q = {},
            _q["& + .".concat(switchLabelIdentifier)] = {
                boxShadow: "0 0 0 1px white, 0 0 0 3px ".concat('#085a7e'),
            },
            _q)
    },
    _h["& + .".concat(switchLabelIdentifier)] = {
        backgroundColor: '#666666',
        border: 'none',
        borderRadius: 16,
        boxSizing: 'border-box',
        cursor: 'pointer',
        display: 'inline-block',
        height: 32,
        padding: 0,
        position: 'relative',
        width: 48,
        ':before': {
            color: '#ffffff',
            fontSize: 14,
            fontWeight: 500,
            left: 4,
            lineHeight: "".concat(24 - 2, "px"),
            margin: 0,
            padding: 0,
            position: 'absolute',
            textAlign: 'center',
            top: 4,
            transition: 'left 0.15s ease-out',
            zIndex: 1,
            backgroundColor: '#ffffff',
            borderRadius: '50%',
            content: '" "',
            height: 24,
            width: 24,
        },
        ':after': {
            display: 'none',
        },
    },
    _h);
export var switchWrapper = {
    display: 'flex',
    height: '100%',
};
